// extracted by mini-css-extract-plugin
module.exports = {"outOfStockPopover":"CartManager_outOfStockPopover__K_0_Q"};